export default function AboutHero() {
  return (
    <section className="relative w-full h-[420px] md:h-[560px] overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Modern%20creative%20agency%20office%20interior%20with%20dramatic%20dark%20atmosphere%20and%20warm%20crimson%20red%20accent%20lighting%2C%20sleek%20minimal%20workspace%20with%20large%20monitors%2C%20team%20collaboration%20space%20with%20glass%20walls%2C%20premium%20corporate%20environment%20at%20night%2C%20cinematic%20photography%2C%20no%20people%2C%20dark%20charcoal%20and%20red%20tones&width=1440&height=800&seq=about-hero-bg-01&orientation=landscape"
          alt="BIFF Digital - Ankara Dijital Pazarlama Ajansı, Growth & Campaign Agency"
          title="BIFF Digital Ankara Ofis"
          width="1440"
          height="800"
          className="w-full h-full object-cover object-center"
          fetchPriority="high"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/70" />
      </div>

      {/* Content */}
      <div className="relative z-10 h-full flex flex-col items-center justify-center text-center px-4 sm:px-6 lg:px-8">
        <p className="text-primary-500 font-bold text-sm tracking-[0.2em] uppercase mb-4">
          TANIYIN
        </p>
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl text-foreground-50 tracking-tighter mb-6">
          BIFF DIGITAL
        </h1>
        <p className="text-sm md:text-lg text-foreground-300 max-w-2xl leading-relaxed mb-2">
          Growth + Strategy + Execution
        </p>
        <p className="text-xs md:text-sm text-foreground-400 max-w-xl leading-relaxed">
          2021'de İzmir'de doğduk. 2023'te Ankara'yı merkez yaptık, 2024'te İstanbul'a açıldık. Bugün üç şehirde, marka stratejisi, performans pazarlama, nöropazarlama ve web geliştirmeyi tek bir büyüme sisteminde birleştiriyoruz.
        </p>
        <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
          <a href="#ne-yapiyoruz" className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-foreground-950 font-bold text-sm rounded-lg hover:bg-primary-600 transition-colors whitespace-nowrap">
            Keşfet
            <i className="ri-arrow-down-line" />
          </a>
          <a href="https://biffdigital.com/#contact" className="inline-flex items-center gap-2 px-6 py-3 border border-foreground-300/40 text-foreground-50 font-bold text-sm rounded-lg hover:bg-foreground-50/10 transition-colors whitespace-nowrap">
            İletişime Geç
            <i className="ri-mail-send-line" />
          </a>
        </div>
      </div>
    </section>
  );
}